import React from 'react'
import {connect} from 'react-redux'
import {change as changeFieldValue, Field, formValueSelector, reduxForm} from 'redux-form';
import $ from 'jquery';
import {bindActionCreators} from 'redux';
import {maxValueMonetario, renderFieldCpfCnpj, renderFieldDataNascimento, renderFieldMonetario, renderTextArea, required, validarCpfCnpjInformado} from '../../../util/inputs';
import {realParaNumber} from '../../../util/numberUtil';
import enviarFechamentoCaixa from '../../../actions/fechamento-caixa/usuario/enviarFechamentoCaixa';
import {
    getAdminEmpresa,
    getFinanceiroAgencia, getFinanceiroCaixa,
    getGestorEmpresa,
    getOperadorEmpresa,
    getPerfisVendedores,
} from '../../../security/securityContext';
import Autorizacao, {validaPerfis} from '../../../security/Autorizacao';
import devolverFechamentoCaixa from '../../../actions/fechamento-caixa/usuario/devolverFechamentoCaixa';
import baixarComprovanteTransferencia from '../../../actions/fechamento-caixa/usuario/baixarComprovanteTransferencia';
import aprovarFechamentoCaixa from '../../../actions/fechamento-caixa/usuario/aprovarFechamentoCaixa';
import buscarComprovantesPagamento from '../../../actions/fechamento-caixa/usuario/buscarComprovantesPagamento';
import {tamanhoArquivoUpload} from '../../../util/applicationContext';
import buscarFechamentoDia from '../../../actions/fechamento-caixa/usuario/buscarFechamentoDia';
import buscarFechamentosCaixa from '../../../actions/fechamento-caixa/usuario/buscarFechamentosCaixa';
import salvarFechamentoCaixa from '../../../actions/fechamento-caixa/usuario/salvarFechamentoCaixa';
import {showErrorMsg, showSuccessMsg} from '../../../util/messagesUtil';

export class ModalFechamentoCaixa extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            comprovante: null,
            nomeComprovante: null,
            comprovantesPagamento: []
        };
        this.submit = this.submit.bind(this);
        this.alterarValorTotal = this.alterarValorTotal.bind(this);
        this.alterarValorDespesas = this.alterarValorDespesas.bind(this);
        this.handleChange = this.handleChange.bind(this)
    }

    componentDidMount() {
        this.buscarComprovantes();
    }

    componentDidUpdate(prevProps) {
        // Se o fechamento mudou, buscar os comprovantes novamente
        if (prevProps.fechamentoCaixa.id !== this.props.fechamentoCaixa.id) {
            this.buscarComprovantes();
        }
    }

    buscarComprovantes() {
        if (this.props.fechamentoCaixa && this.props.fechamentoCaixa.id && this.props.empresaSelecionada && this.props.empresaSelecionada.id) {
            buscarComprovantesPagamento(this.props.empresaSelecionada.id, this.props.fechamentoCaixa.id)
                .then((response) => {
                    this.setState({ comprovantesPagamento: response.data || [] });
                })
                .catch((error) => {
                    console.error('Erro ao buscar comprovantes de pagamento:', error);
                    this.setState({ comprovantesPagamento: [] });
                });
        } else {
            this.setState({ comprovantesPagamento: [] });
        }
    }

    valorDiferenteZero(valor){
        const valorConvertido = realParaNumber(valor)
        return  valorConvertido > 0 || valorConvertido < 0
    }

    validarValoresReaisInfomados() {
        return this.valorDiferenteZero(this.props.totalAdiantamentoBaixado) ||
            this.valorDiferenteZero(this.props.totalAdiantamentoLancado) ||
            this.valorDiferenteZero(this.props.totalDespesas) ||
            this.valorDiferenteZero(this.props.totalLancamentoAReceber) ||
            this.valorDiferenteZero(this.props.totalDeposito) ||
            this.valorDiferenteZero(this.props.totalVendas)

    }

    validarCamposTextoInformados(){
        // eslint-disable-next-line no-undef
        return !_.isNil(this.props.observacao) || !_.isNil(this.props.base64ComprovanteTransferencia);
    }

    fecharModal() {
        $('#modalFechamentoCaixa')
            .modal('hide');
        $('#modalFechamentoCaixa')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.props.reset('formularioFechamentoCaixa')
    }

    submit(values) {
        const parametros = {
            totalTaxaEmbarqueCEA: values.totalTaxaEmbarqueCEA.replace('R$', ''),
            totalTaxaServico: values.totalTaxaServico.replace('R$', ''),
            totalAdiantamentoBaixado: values.totalAdiantamentoBaixado.replace('R$', ''),
            totalAdiantamentoLancado: values.totalAdiantamentoLancado.replace('R$', ''),
            totalDespesas: values.totalDespesas.replace('R$', ''),
            totalImpostoRetido: values.totalImpostoRetido.replace('R$', ''),
            totalTarifaSeguroImpostoRetido: values.totalTarifaSeguroImpostoRetido.replace('R$', ''),
            totalLancamentoAReceber: values.totalLancamentoAReceber.replace('R$', ''),
            observacao: values.observacao,
            base64ComprovanteTransferencia: this.props.base64ComprovanteTransferencia,
            nomeComprovanteTransferencia: this.props.nomeComprovanteTransferencia,
            data: this.props.fechamentoCaixa.dataFechamento,
            idUsuarioEmpresa: this.props.fechamentoCaixa.idUsuarioEmpresa,
            cpfCnpjTitularComprovante: values.cpfCnpjTitularComprovante,
            dataComprovanteDeposito: values.dataComprovanteDeposito,
            
        };
        if (this.state.botao === 'salvar') {            
            this.salvarFechamento(parametros)
        } else {
            if (this.props.empresaSelecionada.habilitadoCpfCnpjTitularComprovante && (!values.cpfCnpjTitularComprovante || !values.dataComprovanteDeposito)) {
                showErrorMsg('Informe os dados CPF/CNPJ TITULAR do Comprovante e DATA Comprovante Deposito');
                return;
            }
            this.enviarFechamento(parametros)
        }
    }

    enviarFechamento(parametros) {
        this.props.enviarFechamentoCaixa(this.props.empresaSelecionada.id, parametros)
            .then(() => {
                showSuccessMsg('Fechamento enviado com sucesso');
                this.fecharModal();
                this.props.buscarFechamentosCaixa(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
                this.props.buscarFechamentoDia(this.props.empresaSelecionada.id)
            })
    }

    salvarFechamento(parametros) {
        this.props.salvarFechamentoCaixa(this.props.empresaSelecionada.id, parametros)
            .then(() => {
                showSuccessMsg('Fechamento salvo com sucesso');
                this.fecharModal();
                this.props.buscarFechamentosCaixa(this.props.empresaSelecionada.id, this.props.paginaAtual, this.props.registrosPorPagina, this.props.filtrosAdicionados);
                this.props.buscarFechamentoDia(this.props.empresaSelecionada.id)
            })
    }

    handleChange(event) {
        const file = event.target.files[0];
        if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
            return
        }
        if (file.size > tamanhoArquivoUpload) {
            showErrorMsg('Tamanho do arquivo excede 20 MB');
            return
        }
        this.converterParaBase64(file)
    }

    removerArquivo() {
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'base64ComprovanteTransferencia', null);
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'nomeComprovanteTransferencia', null);
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'urlComprovanteTransferencia', null);
    }

    converterParaBase64(file) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            this.props.changeFieldValue('formularioFechamentoCaixa',
                'base64ComprovanteTransferencia', reader.result);
            this.props.changeFieldValue('formularioFechamentoCaixa',
                'nomeComprovanteTransferencia', file.name);
        }.bind(this);
    }

    alterarValorDespesas(event) {
        event.preventDefault();
        // Pega o valor atual do totalDeposito
        let valorDeposito = realParaNumber(this.props.totalDeposito);
        
        // Remove o valor antigo de despesas (adiciona de volta, pois foi subtraído antes)
        const valorDespesasAntigo = realParaNumber(this.props.totalDespesas);
        valorDeposito = valorDeposito + valorDespesasAntigo;
        
        // Subtrai o novo valor de despesas informado
        const novoValorDespesas = realParaNumber(event.target.value);
        valorDeposito = valorDeposito - novoValorDespesas;
        
        // Atualiza o totalDeposito
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'totalDeposito', valorDeposito.toString().replace('.', ','));
    }


    alterarValorTotal = (event) => {
        event.preventDefault();
        let valor = realParaNumber(this.props.totalVendas);

        valor = this.calcularValor(valor, event, 'totalFreteRecebido', this.props.totalFreteRecebido, true);
        valor = this.calcularValor(valor, event, 'totalExcessoBagagem', this.props.totalExcessoBagagem, true);
        valor = this.calcularValor(valor, event, 'totalTaxaServico', this.props.totalTaxaServico, true);
        valor = this.calcularValor(valor, event, 'totalAdiantamentoBaixado', this.props.totalAdiantamentoBaixado, true);
        valor = this.calcularValor(valor, event, 'totalCustoCancelamento', this.props.totalCustoCancelamento, true);
        valor = this.calcularValor(valor, event, 'totalCancelamento', this.props.totalCancelamento);
        valor = this.calcularValor(valor, event, 'totalAdiantamentoLancado', this.props.totalAdiantamentoLancado);
        valor = this.calcularValor(valor, event, 'totalImpostoRetido', this.props.totalImpostoRetido);
        valor = this.calcularValor(valor, event, 'totalTarifaSeguro', this.props.totalTarifaSeguro);
        valor = this.calcularValor(valor, event, 'totalComissao', this.props.totalComissao);
        valor = this.calcularValor(valor, event, 'totalDesconto', this.props.totalDesconto);
        valor = this.calcularValor(valor, event, 'totalRecebidoCartao', this.props.totalRecebidoCartao);
        valor = this.calcularValor(valor, event, 'totalRecebidoCartaoSite', this.props.totalRecebidoCartaoSite);
//        valor = this.calcularValor(valor, event, 'totalTarifaSeguroImpostoRetido', this.props.totalTarifaSeguroImpostoRetido);
        valor = this.calcularValor(valor, event, 'totalLancamentoAReceber', this.props.totalLancamentoAReceber);
        this.props.changeFieldValue('formularioFechamentoCaixa',
            'totalDeposito', valor.toString()
                .replace('.', ','));
    };

    calcularValor(valorTotal, event, nomeCampo, total, isSoma) {
        const valor = event.target.name === nomeCampo ? realParaNumber(event.target.value) : realParaNumber(total);
        return isSoma ? valorTotal + valor : valorTotal - valor;
    }

    exibirAnexar() {
        const ehGestorOuOperador = validaPerfis([
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroCaixa(this.props.empresaSelecionada.id),
            getOperadorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id)]);
        if (this.props.base64ComprovanteTransferencia || this.props.urlComprovanteTransferencia) {
            return (
                <div className="row align-items-center mt-2">
                    <div className='col-md-6 label-cancelamento ml-2'>
                        <strong>Comprovante:</strong>
                    </div>
                    <span>{this.props.nomeComprovanteTransferencia}</span>
                    {this.exibirRemoverComprovante()}
                    {this.exibirBaixarComprovante()}
                </div>)
        }
        if (this.props.fechamentoCaixa.idUsuario === this.props.idUsuario || ehGestorOuOperador) {
            return (
                <Autorizacao perfisPermitidos={[
                    ...getPerfisVendedores(this.props.empresaSelecionada.id),
                    getGestorEmpresa(this.props.empresaSelecionada.id),
                    getFinanceiroCaixa(this.props.empresaSelecionada.id),
                    getOperadorEmpresa(this.props.empresaSelecionada.id),
                    getFinanceiroAgencia(this.props.empresaSelecionada.id)
                ]}>
                    <div className='input-wrapper mt-3'>
                        <label className='btn-laranja' htmlFor='input-file'>
                            <div className='row align-items-center'>
                                <i className="material-icons aberto">&#xe2c3;</i>
                                <strong className='ml-2'>Anexar comprovante de depósito</strong>
                            </div>
                        </label>
                        <input id='input-file' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                               onChange={this.handleChange.bind(this)}/>
                    </div>
                    <label style={{fontSize: 'smaller'}}>
                        * Tamanho máximo permitido: 20 MB
                        <br/>
                        * Formatos suportados: PNG, JPEG, PDF
                        <br/>
                        * Se desejar anexar mais de um arquivo de imagem, utilize o seguinte link para uni-los:
                        <a target="_BLANK" href='https://smallpdf.com/pt/jpg-para-pdf'
                           rel='noreferrer'> https://smallpdf.com/pt/jpg-para-pdf.</a>
                        <br/>
                        * Se desejar anexar mais de um arquivo PDF, utilize o seguinte link para uni-los:
                        <a target="_BLANK" href='https://smallpdf.com/pt/juntar-pdf'
                           rel='noreferrer'> https://smallpdf.com/pt/juntar-pdf.</a>
                    </label>
                </Autorizacao>)
        }

        return '';
    }

    baixarComprovante(){
        baixarComprovanteTransferencia(this.props.comprovanteTransferencia, this.props.nomeComprovanteTransferencia).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', this.props.nomeComprovanteTransferencia);
            document.body.appendChild(link);

            link.click();

        });
    }

    exibirBaixarComprovante() {
        if (this.props.urlComprovanteTransferencia) {
            return (<Autorizacao perfisPermitidos={[
                ...getPerfisVendedores(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id)
            ]}>
                <button type="button" className="btn btn-editar"
                        title='Baixar'
                        onClick={() => this.baixarComprovante()}>
                    <i className="material-icons nav-icon" style={{
                        color: '#fa8d42'
                    }}>&#xe2c0;</i>
                </button>
            </Autorizacao>)
        }
        return '';
    }

    exibirRemoverComprovante() {
        const ehGestorOuOperador = validaPerfis([
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getOperadorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroCaixa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id)]);
        if ((this.props.fechamentoCaixa.situacao === 'ABERTO' || this.props.fechamentoCaixa.situacao === 'DEVOLVIDO') && (this.props.fechamentoCaixa.idUsuario === this.props.idUsuario || ehGestorOuOperador)) {
            return (<Autorizacao perfisPermitidos={[
                ...getPerfisVendedores(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id)
            ]}>
                <button type="button" className="btn btn-editar"
                        title='Remover'
                        onClick={() => this.removerArquivo()}>
                    <i className="material-icons nav-icon" style={{
                        color: 'red'
                    }}>&#xe14c;</i>
                </button>
            </Autorizacao>)
        }
    }

    baixarComprovantePagamento(identificacaoComprovante, nomeComprovante) {
        baixarComprovanteTransferencia(identificacaoComprovante, nomeComprovante || 'comprovante.pdf').then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', nomeComprovante || 'comprovante.pdf');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }

    exibirComprovantesPagamento() {
        const comprovantes = this.state.comprovantesPagamento || [];

        if (comprovantes.length === 0) {
            return '';
        }

        return (
            <div className="mt-3 mb-3">
                <label className="form-label"><strong>Comprovantes de Pagamento:</strong></label>
                <div className="ml-3 mt-2">
                    <table className="table table-sm table-bordered">
                        <thead>
                            <tr>
                                <th style={{width: '150px'}}>Número</th>
                                <th>Forma de Pagamento</th>
                                <th>Comprovantes</th>
                            </tr>
                        </thead>
                        <tbody>
                            {comprovantes.map((comprovante, index) => (
                                <tr key={index}>
                                    <td>
                                        {comprovante.idPedido}
                                    </td>
                                    <td>
                                        {comprovante.descricaoFormaPagamento || '-'}
                                    </td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <span className="mr-2">{comprovante.nomeComprovante || 'Sem comprovante'}</span>
                                            {comprovante.identificacaoComprovante ? (
                                                <button 
                                                    type="button" 
                                                    className="btn btn-sm btn-editar"
                                                    title="Baixar comprovante"
                                                    onClick={() => this.baixarComprovantePagamento(
                                                        comprovante.identificacaoComprovante, 
                                                        comprovante.nomeComprovante || `comprovante_pedido_${comprovante.idPedido}.pdf`
                                                    )}>
                                                    <i className="material-icons nav-icon" style={{
                                                        color: '#fa8d42',
                                                        fontSize: '18px'
                                                    }}>&#xe2c0;</i>
                                                </button>
                                            ) : (
                                                <span className="text-muted" style={{fontSize: '12px'}}>Sem comprovante</span>
                                            )}
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    exibirBotoesVendedor(invalid, submitting, exibirBotaoSalvar) {
        const ehGestorOuOperador = validaPerfis([
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getOperadorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroCaixa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id)]);

        if (this.props.fechamentoCaixa.situacao === 'ABERTO' || this.props.fechamentoCaixa.situacao === 'DEVOLVIDO') {
            return (
                <div className="modal-footer">
                    <button id="btn-cancelar-acesso-autos" className="btn btn-azul" data-dismiss="modal"
                            disabled={submitting}>
                        CANCELAR
                    </button>
                    {this.props.fechamentoCaixa.idUsuario === this.props.idUsuario || ehGestorOuOperador
                        ? <Autorizacao perfisPermitidos={[
                            ...getPerfisVendedores(this.props.empresaSelecionada.id),
                            getGestorEmpresa(this.props.empresaSelecionada.id),
                            getFinanceiroCaixa(this.props.empresaSelecionada.id),
                            getOperadorEmpresa(this.props.empresaSelecionada.id),
                            getFinanceiroAgencia(this.props.empresaSelecionada.id)
                        ]}>
                            <button type="submit" title='Salvar custos do dia' className="btn btn-azul"
                                    onClick={() => this.setState({botao: 'salvar'})} disabled={invalid || submitting || !exibirBotaoSalvar}>
                                SALVAR
                            </button>
                            <button type="submit" title='Enviar para aprovação do gestor' className="btn btn-azul"
                                    onClick={() => this.setState({botao: 'enviar'})}
                                    disabled={invalid || submitting || !this.props.nomeComprovanteTransferencia}>
                                ENVIAR
                            </button>
                        </Autorizacao> : ''}
                </div>)
        }
        return ''
    }

    devolverFechamentoCaixa() {
        this.props.devolverFechamentoCaixa(this.props.fechamentoCaixa.id, this.props.observacao, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Fechamento devolvido com sucesso');
                this.fecharModal();
                this.props.buscaFechamentos(this.props.data);
                this.props.buscarFechamentoDia(this.props.empresaSelecionada.id)
            })
    }

    aprovarFechamentoCaixa() {
        this.props.aprovarFechamentoCaixa(this.props.fechamentoCaixa.id, this.props.observacao, this.props.empresaSelecionada.id)
            .then(() => {
                showSuccessMsg('Fechamento aprovado com sucesso');
                this.fecharModal();
                this.props.buscaFechamentos(this.props.data);
                this.props.buscarFechamentoDia(this.props.empresaSelecionada.id)
            })
    }


    exibirBotoesGestorOperador() {
        if (this.props.fechamentoCaixa.situacao === 'ENVIADO') {
            return (
                <div className="modal-footer">
                    <button id="btn-cancelar-acesso-autos" className="btn btn-azul" data-dismiss="modal">
                        CANCELAR
                    </button>
                    <Autorizacao perfisPermitidos={[getGestorEmpresa(this.props.empresaSelecionada.id),
                        getOperadorEmpresa(this.props.empresaSelecionada.id),
                        getFinanceiroCaixa(this.props.empresaSelecionada.id),
                        getAdminEmpresa(this.props.empresaSelecionada.id)]}>
                        <button className="btn btn-vermelho" id="btn-confirmar-acesso-autos"
                                onClick={() => this.devolverFechamentoCaixa()}>
                            DEVOLVER
                        </button>
                        <button className="btn btn-laranja" id="btn-confirmar-acesso-autos"
                                onClick={() => this.aprovarFechamentoCaixa()}>
                            APROVAR
                        </button>
                    </Autorizacao>
                </div>)
        }
        return ''
    }


    render() {
        const {
            handleSubmit, submitting, invalid
        } = this.props;

        const exibirBotaoSalvar = this.validarValoresReaisInfomados() || this.validarCamposTextoInformados()

        const ehGestorOuOperador = validaPerfis([
            getGestorEmpresa(this.props.empresaSelecionada.id),
            getAdminEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroCaixa(this.props.empresaSelecionada.id),
            getOperadorEmpresa(this.props.empresaSelecionada.id),
            getFinanceiroAgencia(this.props.empresaSelecionada.id)]);

        const naoPodeAlterarValores = !validaPerfis([
                ...getPerfisVendedores(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id)])
            || (this.props.fechamentoCaixa.id && (this.props.fechamentoCaixa.situacao === 'ENVIADO' || this.props.fechamentoCaixa.situacao === 'APROVADO'))
            || (this.props.fechamentoCaixa.idUsuario !== this.props.idUsuario && !ehGestorOuOperador);

        const exibirCampoComentario = (validaPerfis([
                ...getPerfisVendedores(this.props.empresaSelecionada.id),
                getGestorEmpresa(this.props.empresaSelecionada.id),
                getFinanceiroAgencia(this.props.empresaSelecionada.id),
                getFinanceiroCaixa(this.props.empresaSelecionada.id),
                getOperadorEmpresa(this.props.empresaSelecionada.id)]) && (this.props.fechamentoCaixa.situacao === 'ABERTO' || this.props.fechamentoCaixa.situacao === 'DEVOLVIDO')
            && (this.props.fechamentoCaixa.idUsuario === this.props.idUsuario || ehGestorOuOperador))
            || (validaPerfis([getAdminEmpresa(this.props.empresaSelecionada.id),
              getGestorEmpresa(this.props.empresaSelecionada.id)]) && (this.props.fechamentoCaixa.situacao === 'ENVIADO'));

        return (
            <div className="modal fade show" id="modalFechamentoCaixa" role="dialog"
                 aria-labelledby="modalFechamentoCaixa"
                 aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="modal-title">
                                <h5>
                                    {this.props.fechamentoCaixa.nomeUsuario} - {this.props.fechamentoCaixa.dataFechamento}
                                </h5>
                            </div>
                            <button id="btn-cabecalho-modal" className="close" type="button" data-dismiss="modal"
                                    aria-label="Close" onClick={() => this.fecharModal()}>
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <form onSubmit={handleSubmit(this.submit)}>
                            <div className='modal-body'>
                                <Field name='totalTaxaServico' validate={[required, maxValueMonetario]}
                                       component={renderFieldMonetario} className="form-control"
                                       label='(+) Total Tx de Serviço' readOnly/>
                                <Field name='totalPedagio' validate={[required, maxValueMonetario]}
                                       component={renderFieldMonetario} className="form-control"
                                       label='(+) Total Tx de Pedágio' readOnly/>
                                <Field name='totalAdiantamentoBaixado' validate={[required, maxValueMonetario]}
                                       component={renderFieldMonetario} className="form-control"
                                       label="(+) Total adiantamento baixado" handleChange={this.alterarValorTotal}
                                       readOnly={naoPodeAlterarValores}/>
                                <Field name='totalAdiantamentoLancado' validate={[required, maxValueMonetario]}
                                       component={renderFieldMonetario} className="form-control"
                                       label="(-) Total adiantamento lançado" handleChange={this.alterarValorTotal}
                                       readOnly={naoPodeAlterarValores}/>
                                <Field name='totalDespesas' validate={[required, maxValueMonetario]}
                                       component={renderFieldMonetario} className="form-control"
                                       label="(-) Total despesas" handleChange={this.alterarValorDespesas}
                                       readOnly={naoPodeAlterarValores}/>
                                <Field name='totalLancamentoAReceber' validate={[required, maxValueMonetario]}
                                       component={renderFieldMonetario} className="form-control"
                                       label="(-) Total Lançamentos a receber" handleChange={this.alterarValorTotal}
                                       readOnly={naoPodeAlterarValores}/>
                                <Field name='totalTarifaSeguro' validate={[required, maxValueMonetario]}
                                       component={renderFieldMonetario} className="form-control"
                                       label='(-) Total de seguro' readOnly/>
                                <Field name='totalImpostoRetido' validate={[required, maxValueMonetario]}
                                       component={renderFieldMonetario} className="form-control"
                                       label="(-) Total imposto retido" readOnly/>
                                <Field name='totalTarifaSeguroImpostoRetido' validate={[required, maxValueMonetario]}
                                       component={renderFieldMonetario} className="form-control"
                                       label="(-) Total de tarifa seguro e imposto retido" readOnly/>
                                <Field name='totalVendas' validate={[required]} component={renderFieldMonetario}
                                       className="form-control" label='(+) Total de vendas' readOnly/>
                                <Field name='totalRecebidoCartao' validate={[required]} component={renderFieldMonetario}
                                       className="form-control" label="(-) Total recebido cartão" readOnly/>
                                <Field name='totalRecebidoCartaoSite' validate={[required]} component={renderFieldMonetario}
                                       className="form-control" label="(-) Total recebido cartão no site" readOnly/>
                                <Field name='totalRecebidoPix' validate={[required]} component={renderFieldMonetario}
                                       className="form-control" label="(-) Total recebido PIX" readOnly/>
                                <Field name='totalCancelamento' validate={[required]} component={renderFieldMonetario}
                                       className="form-control" label="(-) Total de cancelamentos" readOnly/>
                                <Field name='totalCustoCancelamento' validate={[required]}
                                       component={renderFieldMonetario} className="form-control"
                                       label="(+) Total de residual de cancelamentos" readOnly/>
                                <Field name='totalExcessoBagagem' validate={[required]} component={renderFieldMonetario}
                                       className="form-control" label='(+) Total excesso bagagem' readOnly/>
                                <Field name='totalComissao' validate={[required]} component={renderFieldMonetario}
                                       className="form-control" label="(-) Total comissão" readOnly/>
                               <Field name='totalReimpressaoRecibo' validate={[required]} component={renderFieldMonetario}
                                      className="form-control" label="(-) Total comissão Reimpressão" readOnly/>
                                <Field name='totalDesconto' validate={[required]} component={renderFieldMonetario}
                                       className="form-control" label="( Informativo ) Total desconto" readOnly/>
                                <Field name='totalTaxaEmbarqueCEA' validate={[required, maxValueMonetario]}
                                       component={renderFieldMonetario} className="form-control"
                                       label='(=) Total Tx de Embaque CEA'
                                       handleChange={this.alterarValorTotal} readOnly/>
                                <Field name='totalDeposito' validate={[required]} component={renderFieldMonetario}
                                       className="form-control" label="(=) Total do deposito" readOnly/>
                                {exibirCampoComentario ?
                                    <Field name='observacao' css="form-control col-md-12" component={renderTextArea}
                                           className="form-control" max={1500} label="Seu comentário:"/> : ''}                                           
                                {this.props.fechamentoCaixa.situacao === 'ABERTO' && !this.props.fechamentoCaixa.ultimoHistorico ? '' :
                                    <Field name='ultimoComentario' css="form-control col-md-12"
                                           component={renderTextArea} className="form-control"
                                           label="Último comentário:" readOnly={true}/>}
                                {this.exibirComprovantesPagamento()}
                                {this.props.empresaSelecionada.habilitadoCpfCnpjTitularComprovante ? 
                                    <><Field name='cpfCnpjTitularComprovante' type="text" component={renderFieldCpfCnpj} label="CPF/CNPJ - TITULAR DO COMPROVANTE:"
                                        validate={[validarCpfCnpjInformado]} css="form-control" readOnly={false} />
                                    <Field name='dataComprovanteDeposito' type="text" max={10} component={renderFieldDataNascimento}
                                        label='Data Comprovante Depósito' css="form-control" />
                                        </>: ''}
                                {this.exibirAnexar()}
                            </div>
                            {this.exibirBotoesVendedor(invalid, submitting, exibirBotaoSalvar)}
                        </form>
                        {this.exibirBotoesGestorOperador()}
                    </div>
                </div>
            </div>
        )
    }
}

const selector = formValueSelector('formularioFechamentoCaixa');

export function mapStateToProps(state) {    
    return {
        vendas: state.vendas,
        empresaSelecionada: state.empresaSelecionada,
        fechamentoCaixa: state.fechamentoCaixa,
        idUsuario: state.authentication.idUsuario,
        paginaAtual: state.paginaAtualFechamentoCaixa,
        filtrosAdicionados: state.filtrosAdicionadosFechamentoCaixa,
        registrosPorPagina: state.registrosPorPaginaFechamentoCaixa,
        initialValues: {
            totalTaxaEmbarqueCEA: state.fechamentoCaixa.totais.totalTaxaEmbarqueCEA,
            totalTaxaServico: state.fechamentoCaixa.totais.totalTaxaServico,
            totalPedagio: state.fechamentoCaixa.totais.totalPedagio,
            totalTarifaSeguro: state.fechamentoCaixa.totais.totalTarifaSeguro,
            totalAdiantamentoBaixado: state.fechamentoCaixa.totais.totalAdiantamentoBaixado,
            totalAdiantamentoLancado: state.fechamentoCaixa.totais.totalAdiantamentoLancado,
            totalDespesas: state.fechamentoCaixa.totais.totalDespesas,
            totalImpostoRetido: state.fechamentoCaixa.totais.totalImpostoRetido,
            totalTarifaSeguroImpostoRetido: state.fechamentoCaixa.totais.totalTarifaSeguroImpostoRetido,
            totalVendas: state.fechamentoCaixa.totais.totalVendas,
            totalRecebidoCartao: state.fechamentoCaixa.totais.totalRecebidoCartao,
            totalRecebidoCartaoSite: state.fechamentoCaixa.totais.totalRecebidoCartaoSite,
            totalCancelamento: state.fechamentoCaixa.totais.totalCancelamento,
            totalCustoCancelamento: state.fechamentoCaixa.totais.totalCustoCancelamento,
            totalExcessoBagagem: state.fechamentoCaixa.totais.totalExcessoBagagem,
            totalFreteRecebido: state.fechamentoCaixa.totais.totalFreteRecebido,
            totalComissao: state.fechamentoCaixa.totais.totalComissao,
            totalReimpressaoRecibo: state.fechamentoCaixa.totais.totalReimpressaoRecibo,
            totalDesconto: state.fechamentoCaixa.totais.totalDesconto,
            totalDeposito: state.fechamentoCaixa.totais.totalDeposito,
            totalRecebidoPix: state.fechamentoCaixa.totais.totalRecebidoPix,
            totalLancamentoAReceber: state.fechamentoCaixa.totais.totalLancamentoAReceber,
            ultimoComentario: state.fechamentoCaixa.ultimoHistorico ? state.fechamentoCaixa.ultimoHistorico.observacao : '',
            urlComprovanteTransferencia: state.fechamentoCaixa.urlComprovanteTransferencia ? state.fechamentoCaixa.urlComprovanteTransferencia : null,
            nomeComprovanteTransferencia: state.fechamentoCaixa.nomeComprovanteTransferencia ? state.fechamentoCaixa.nomeComprovanteTransferencia : null,
            comprovanteTransferencia: state.fechamentoCaixa.comprovanteTransferencia ? state.fechamentoCaixa.comprovanteTransferencia : null,
            cpfCnpjTitularComprovante: state.fechamentoCaixa.cpfCnpjTitularComprovante,
            dataComprovanteDeposito: state.fechamentoCaixa.dataComprovanteDeposito,
        },
        totalTaxaEmbarqueCEA: selector(state, 'totalTaxaEmbarqueCEA'),
        totalCancelamento: selector(state, 'totalCancelamento'),
        totalCustoCancelamento: selector(state, 'totalCustoCancelamento'),
        totalTaxaServico: selector(state, 'totalTaxaServico'),
        totalAdiantamentoBaixado: selector(state, 'totalAdiantamentoBaixado'),
        totalAdiantamentoLancado: selector(state, 'totalAdiantamentoLancado'),
        totalDespesas: selector(state, 'totalDespesas'),
        totalImpostoRetido: selector(state, 'totalImpostoRetido'),
        totalTarifaSeguroImpostoRetido: selector(state, 'totalTarifaSeguroImpostoRetido'),
        totalVendas: selector(state, 'totalVendas'),
        totalRecebidoCartao: selector(state, 'totalRecebidoCartao'),
        totalRecebidoCartaoSite: selector(state, 'totalRecebidoCartaoSite'),
        totalFrete: selector(state, 'totalFrete'),
        totalExcessoBagagem: selector(state, 'totalExcessoBagagem'),
        totalComissao: selector(state, 'totalComissao'),
        totalReimpressaoRecibo: selector(state, 'totalReimpressaoRecibo'),
        totalDesconto: selector(state, 'totalDesconto'),
        totalDeposito: selector(state, 'totalDeposito'),
        totalLancamentoAReceber: selector(state, 'totalLancamentoAReceber'),
        urlComprovanteTransferencia: selector(state, 'urlComprovanteTransferencia'),
        nomeComprovanteTransferencia: selector(state, 'nomeComprovanteTransferencia'),
        comprovanteTransferencia: selector(state, 'comprovanteTransferencia'),
        base64ComprovanteTransferencia: selector(state, 'base64ComprovanteTransferencia'),
        observacao: selector(state, 'observacao'),
        cpfCnpjTitularComprovante: selector(state, 'cpfCnpjTitularComprovante'),
        dataComprovanteDeposito:  selector(state, 'dataComprovanteDeposito'),
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        enviarFechamentoCaixa,
        aprovarFechamentoCaixa,
        devolverFechamentoCaixa,
        buscarFechamentoDia,
        buscarFechamentosCaixa,
        salvarFechamentoCaixa
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formularioFechamentoCaixa',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
})(ModalFechamentoCaixa))
